'use client';

import { useEffect, useRef, useCallback } from 'react';

interface SliderControlsProps {
  totalSlides: number;
  currentSlide: number;
  onSlideChange: (index: number) => void;
  autoplay?: boolean;
  autoplayInterval?: number;
}

export default function SliderControls({ 
  totalSlides, 
  currentSlide, 
  onSlideChange,
  autoplay = false,
  autoplayInterval = 5000
}: SliderControlsProps) {
  const currentSlideRef = useRef<number>(currentSlide);

  const nextSlide = useCallback(() => {
    const next = (currentSlideRef.current + 1) % totalSlides;
    currentSlideRef.current = next;
    onSlideChange(next);
  }, [totalSlides, onSlideChange]);

  // Initialize autoplay
  useEffect(() => {
    if (autoplay) {
      const interval = setInterval(() => {
        nextSlide();
      }, autoplayInterval);
      return () => clearInterval(interval);
    }
  }, [autoplay, autoplayInterval, nextSlide]);

  // This component doesn't render anything visible
  return null;
} 